import React, { useContext, useEffect, useRef, useState } from 'react';
import { Body, Footer, Header, Main, closeAnimation } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input from '../../NecttosComp/Input/Input';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';
import GoogleDocsCreator from '../../NecttosComp/Editor/GoogleDocsCreator';
import { ProgressBar } from '../../NecttosComp/ProgressBar/ProgressBar';
import MultiProgressBar from '../../NecttosComp/ProgressBar/MultiProgressBar';
import toast,{Toast, Toaster} from 'react-hot-toast';
import Instruction from '../../Documentation/Instruction';


const getAllTemplate = (collegeId: any) => async () => {
    const instance = await getAxiosTokenInstance();
    try {
        const resp = await instance.get('/college/action/getAllDDFSTemplates', {
            params: { collegeId },
        });
        if (resp.data.statusCode === 400) {
            throw new Error(resp.data.message || 'API Error');
        } else {
            return resp?.data?.list;
        }
    } catch (error) {
        throw new Error('API Error');
    }
};
const getHierarchy = (collegeId: any) => async () => {
    const instance = await getAxiosTokenInstance();
    try {
        const resp = await instance.get('/college/action/getAllHierarchy', {
            params: { collegeId },
        });
        if (resp.data.statusCode === 400) {
            throw new Error(resp.data.message || 'API Error');
        } else {
            return resp?.data?.list;
        }
    } catch (error) {
        throw new Error('API Error');
    }
};

interface invoiceManagementProps {
    onClose: () => void;
}
function TemplateManagement({ onClose }: invoiceManagementProps) {
    const [values, setValues] = useState<any>({});
    const [showForm, setShowForm] = useState(false);
    const { collegeId } = useContext(FirebaseContext);
    const ref = useRef<any>(null);
    const [docId, setDocId] = useState<string>('');

    const userskey = ['effectFrom', 'effectTo', 'userIds', 'type'];

    const { data: tableData = [], refetch } = useQuery('getAllAccadamicHolidays', getAllTemplate(collegeId));
    const { data: hierarchy = [] } = useQuery('getUsers', getHierarchy(collegeId));

  // Delete doc if the parent sets deleteDoc = true
  const deleteGoogleDoc = async (docIdToDelete: string) => {
    const instance = await getAxiosTokenInstance();
    try {
      
      const {data } = await instance.post("/googleDocs/deleteDoc", {
        docId: docIdToDelete,
      });

      if (data.error) {
        toast.error(data.error);
      } else {
        toast.success("Document deleted successfully");
        setDocId('');
      }
    } catch (error) {
      console.error("Error deleting document:", error);
    } 
  };



    const handleDelete = async (_id: string) => {
        try {
            const instance = await getAxiosTokenInstance();
           await deleteGoogleDoc(docId)
            instance
                .delete('/college/action/deleteddfsTemplates/' + _id, { params: { collegeId } })
                .then(() => {
                    refetch();
                })
                .catch((err: any) => {
                    console.error(err);
                });
        } catch (err) {
            console.log(err);
        }
    };

    const valuesForm = async () => {
        try {
            if (!values?.title || values?.hierarchy.length === 0 || values?.hierarchy === undefined || values?.hierarchy.find((x: any) => x._id === undefined)) {
                toast.error("Please select all the roles")
                return;
            }
            if (!docId) {
                toast.error("Please create a template")
                return
            }
            values?.hierarchy.map((x: any, index: number) => {
                x.weight = index + 1;
            })
            const instance = await getAxiosTokenInstance();
            instance
                .post('/college/action/postDDFSTemplates', { ...values, docId, collegeId })
                .then(() => {
                    setValues({});
                    setDocId('');
                    refetch();
                })
                .catch((err: any) => {
                    console.error(err);
                });

            closeAnimation();
            setTimeout(() => setShowForm(false), 500);
        } catch (err) {
            throw new Error('API Error');
        }
    };
    const onAddClick = (type: string) => {
        const currentData = Array.isArray(values?.[type]) ? values[type] : [];
        const newData = [...currentData, {}];
        setValues({ ...values, [type]: newData });
    };

    const onDelete = (index: any, arrayName: any) => {
        setValues((prevValues: any) => {
            const updatedArray = [...prevValues[arrayName]];
            updatedArray.splice(index, 1);
            return { ...prevValues, [arrayName]: updatedArray };
        });
    };


    return (
        <>
                <Toaster />
            <Main title='DDFS Template Management' width='90vw' height='90vh'>
                <Header >
                    <div className='flex'>
                        <Button type='save' onClick={() =>{setDocId(''); setShowForm(true)}}>
                            + New
                        </Button>
                    </div>
                    <div className='flex'>
                        <Instruction keyId={'templateManagement'}/>
                        <Button type='close' onClick={onClose}>
                            Close
                        </Button>
                    </div>
                </Header>
                <Body>
                    <div ref={ref} className='h-[75vh] pt-2 printable overflow-auto'>
                        <Table width='100%' innerWidth={['5%', '15%', '35%', '15%', '10%', '10%']}>
                            <Thead>
                                <Tr>
                                    <Th position={0}>Sl.No.</Th>
                                    <Th position={1}>Title</Th>
                                    <Th position={2}>Hierarchy</Th>
                                    <Th position={3}>Template</Th>
                                    <Th position={4}>Action</Th>
                                </Tr>
                            </Thead>
                            <Tbody height='auto'>
                                {tableData?.map((x: any, i: number) => (
                                    <Tr key={i}>
                                        <Td index={i} position={0}>
                                            {i + 1}
                                        </Td>
                                        <Td index={i} position={1}>
                                            {x?.title}
                                        </Td>
                                        <Td index={i} position={2}>
                                            <MultiProgressBar points={x.roles} containerWidth='75%' />
                                        </Td>
                                        <Td index={i} position={3}>
                                            {x?.docId && <a href={`https://docs.google.com/document/d/${x?.docId}/edit`} target='_blank' rel='noreferrer'>
                                                View
                                            </a>}
                                        </Td>
                                        <Td index={i} position={4}>
                                            <div className='flex'>
                                                <Button
                                                    type='update'
                                                    onClick={() => {
                                                        setValues(x);
                                                        setDocId(x?.docId);
                                                        setShowForm(true);
                                                    }}>
                                                    Edit
                                                </Button>
                                                <Button type='delete' onClick={() => handleDelete(x?._id)}>
                                                    Delete
                                                </Button>
                                            </div>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </div>
                </Body>
            </Main>


            {showForm && (
                <Main width='80vw' height='100%' zIndex='1000'>
                    <Header>
                        <Button
                            type='close'
                            onClick={() => {
                                closeAnimation();
                                setTimeout(() => { setShowForm(false); setDocId(''); setValues({}) }, 500);
                            }}>
                            Close
                        </Button>
                    </Header>
                    <Body>
                        <div className='flex flex-col w-full'>
                            <Input2 width='100%' fieldName='Template title' keyId='titl' returnKey='title' state={values} setState={setValues} type='text' />

                            <div className='bg-gray-100 dark:bg-black shadow-md p-4 rounded-lg mb-4'>
                                {values?.hierarchy?.length >= 0 ? (
                                    <>
                                        {values?.hierarchy?.map((member: any, index: any) => (
                                            <div key={member.id || index} className='bg-gray-100  dark:bg-gray-900 shadow-md p-1 rounded-lg mb-2'>
                                                <div className='flex justify-between items-center'>
                                                    <span className='text-lg dark:text-gray-100 font-bold'>Person {index + 1}</span>
                                                    <Button type='close' onClick={() => onDelete(index, 'hierarchy')}>
                                                        Delete
                                                    </Button>
                                                </div>
                                                <div key={index + 1} className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
                                                    <Input2
                                                        className="w-[300px]"
                                                        isArray={true}
                                                        indexVal={index}
                                                        arrayName="hierarchy"
                                                        fieldName="Select Role *"
                                                        // Show 'role' in the dropdown
                                                        optionDisplay="role"
                                                        // Use '_id' as the unique key we store in the state
                                                        optionKey="_id"
                                                        // Tells Drop which key in state to update
                                                        returnKey="_id"
                                                        inputValue={index}
                                                        key={index}
                                                        // Provide the array of roles/IDs
                                                        options={hierarchy}
                                                        valueShowKey='role'
                                                        // The top-level component's state
                                                        state={values}
                                                        setState={setValues}
                                                        // Type is 'drop'
                                                        type="drop"
                                                    />

                                                </div>
                                            </div>
                                        ))}
                                        <Button type='save' onClick={() => onAddClick('hierarchy')}>
                                            Add +
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <span className='text-center text-gray-500 dark:text-gray-300 my-10'>Add users Members</span>
                                        <Button type='save' onClick={() => onAddClick('hierarchy')}>
                                            Add +
                                        </Button>
                                    </>
                                )}
                            </div>

                            {/* template text editor */}
                            <div className='bg-gray-100 dark:bg-black shadow-md p-4 rounded-lg mb-4'>
                                {values?.title && <GoogleDocsCreator  docId={docId} setDocId={setDocId} title={values?.title} mode='edit' />}

                            </div>


                            <Button
                                type='save'
                                onClick={() => {
                                    valuesForm();
                                }}>
                                Save
                            </Button>
                        </div>
                    </Body>
                </Main>
            )}


        </>
    );
}

export default TemplateManagement